export const usersNavBar = [
  {
    text: "Users",
    icon: "mdi-account-multiple-plus",
    to: "/users",
  },
];
